import { styled } from '@clickcease/cc-client-components-lib'

export const FaqStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '1120px',
  margin: '125px 0px 129px 0px',
  color: '$black',

  '@bp1': {
    width: '90%',
    margin: '70px 0px $20 0px',
  },

  variants: {
    bundleMobile: {
      true: {
        marginBottom: '300px',
      },
    },
  },
})

export const FaqTitle = styled('div', {
  fontSize: '$hxl',
  fontWeight: '$b',
  marginBottom: '74px',

  '@bp1': {
    marginBottom: '$20',
  },
})
